/**
 * Carrier Logo options for ComplianceCarrierLogoId (Spec 0039 M-5).
 *
 * Zentrale Konstante — wird spaeter (Phase 2: DynamoDB-CRUD)
 * durch einen API-Aufruf ersetzt. Bis dahin statisch.
 */
export const CARRIER_LOGO_OPTIONS = [
  { id: 1, label: 'Telekom' },
  { id: 2, label: 'Vodafone' },
  { id: 3, label: 'Telefonica (O2)' },
  { id: 4, label: 'Freenet' },
  { id: 10, label: 'DE-Kombi (T/V/O)' },
  { id: 11, label: 'DE-Alle (T/V/O/F)' },
] as const;

/**
 * Resolve a CarrierLogoId to its display label.
 * Returns undefined if the ID is unknown.
 */
export function getCarrierLogoLabel(id: number | undefined): string | undefined {
  if (id === undefined) return undefined;
  return CARRIER_LOGO_OPTIONS.find((opt) => opt.id === id)?.label;
}
